
import styles from "./PartWorkItemAdminUsed.module.scss";
import { useState } from "react";

import checkicon from 'assets/icons/check.png'
import circleicon from 'assets/icons/circle.png'
import squareicon from 'assets/icons/square.png'
import checksquareicon from 'assets/icons/square_check.png'
import pieeeeechart from 'assets/icons/pieeeeechart.png'
import Notification from "utils/Notifications";

import { updatePointsPart } from "service/TestService";
import { EditorState, convertFromRaw } from "draft-js";
import { Editor } from "react-draft-wysiwyg";

const PartWorkItemUse = ({ item, item_selected, item_selected_data, index, setRender }) => {


    const [notify, setNotify] = useState({
        isOpen: false,
        message: "",
        type: "",
    });



    const DraftContent = ({ draftData }) => {
        // Преобразуем данные из текста в объект
        let contentState;
        try {
            const parsedData = typeof draftData === "string" ? JSON.parse(draftData) : draftData;
            contentState = convertFromRaw(parsedData);
        } catch (error) {
            console.error("Ошибка обработки данных Draft.js:", error);
            return <p>Invalid content format</p>;
        }

        // Создаём состояние редактора для отображения
        const editorState = EditorState.createWithContent(contentState);

        return (
            <div st>
                <Editor editorState={editorState} readOnly toolbarHidden />
            </div>
        );
    };




    const [text, setText] = useState('');
    const [settextelem, setTextElem] = useState(null);

    const handleChange = (event) => {
        const inputValue = Number(event.target.value); // Преобразуем введенное значение в число

        if (inputValue > item.max_points_for_the_correct_answer) {
            setText(item.max_points_for_the_correct_answer); // Если значение больше 100, сбрасываем до 100
        } else if (inputValue < 0) {
            setText(0); // Если значение меньше 0, сбрасываем до 0 (опционально)
        } else {
            setText(inputValue); // Иначе обновляем состояние введенным значением
        }
    };


    const handleSubmit = () => {
        try {
            const formData = new FormData();

            // Общие данные

            formData.append('text', text)
            updatePointsPart(item_selected_data[0]?.id, formData);
            setTextElem("В ожидании обновления");
            setNotify({
                isOpen: true,
                message: "Данные успешно отправлены!",
                type: "success",
            });
            setRender(true);
        } catch (error) {
            console.error("Ошибка отправки данных:", error);
            setNotify({
                isOpen: true,
                message: "Ошибка при отправке данных!",
                type: "error",
            });
        }
    };
    return (


        <div className={styles.answer_card_selection} >
            <>
                {item_selected_data[0]?.admin_checked === true &&
                    <div>

                        <h2 style={{ color: "#b20000" }}>Требуется внимание администратора!</h2>
                        <h3>Вам необходимо проверить и выставить баллы за это задание</h3>
                        <h3>Максимальное кол-во баллов: <span className={styles.answer_chec_under}>{item.max_points_for_the_correct_answer}б</span></h3>
                        {settextelem === null ? (
                            <div style={{ display: 'flex', flexDirection: 'row', gap: "20px" }}>
                                <input
                                    type="number"
                                    value={text}
                                    onChange={handleChange}
                                    min={0}
                                    max={item.max_points_for_the_correct_answer}
                                    style={{ border: '1px solid rgb(41, 33, 33)', padding: '10px 10px', borderRadius: '6px', border: '0', fontSize: '14px' }}
                                    placeholder="Баллы"
                                />
                                <button
                                    onClick={handleSubmit}
                                    style={{

                                        padding: "10px 20px",
                                        backgroundColor: "#0E7500",
                                        color: "#fff",
                                        border: "none",
                                        cursor: "pointer",
                                        borderRadius: "5px",
                                    }}
                                >
                                    Выставить баллы
                                </button>
                            </div>
                        ) : <h2>{settextelem}</h2>}
                    </div>
                }

                <h2 className={styles.answer_card_selection_header_h2} key={index}>
                    <span>
                        <img
                            src={pieeeeechart}
                            className={styles.img}
                            alt='sdfsd'
                        />

                        {item_selected_data[0]?.points}
                    </span>
                </h2>
            </>
            {item.image &&
                <img
                    src={item.image}
                    className={styles.img_file}
                />
            }
            <div className={styles.answer_card_selection_body}>

                <h3 style={{ marginTop: "-16px" }}> <DraftContent draftData={item.body} /></h3>
                {((Number(item_selected) !== Number(item.id)) && item.type_answer !== "infoText") &&

                    <div className={styles.answer_card_selection_body_answer}>
                        Не отвечено пользователем или Новый вопрос теста 
                    </div>
                }
                {Number(item_selected) === Number(item.id) &&
                    <>



                        {(item.type_answer !== "freeTextAnswer" && item.type_answer !== "infoText" && item.type_answer !== 'fileUpload') &&
                            <h4 style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', width: "100%", flexDirection: "column", gap: '20px', marginBottom: '30px' }}>


                                {item.checkpoints === false &&
                                    <>
                                        <span>За <span className={styles.point_color_1}>правильный</span> ответ: <span className={styles.answer_check}>{item.points_for_the_correct_answer}б</span></span>
                                        <span>За  <span className={styles.point_color_2}>неправильный</span> ответ: <span className={styles.answer_chec_under}>{item.points_for_the_wrong_answer}б</span></span></>
                                }
                            </h4>
                        }
                        <h4 style={{ display: 'flex', alignItems: 'start', justifyContent: 'start', width: "100%", flexDirection: "column" }}>  Ответ пользователя:</h4>
                        <div className={styles.answer_card_selection_body_answer}>
                            {item.answer_part_worktest.map((answer, index) => (
                                <>

                                    <div style={{ width: '100%' }}>
                                        {(item.type_answer !== "freeTextAnswer" && item.type_answer !== "infoText" && item.type_answer !== 'fileUpload') ? (
                                            <div className={styles.answer_card_header}>
                                                {(item.checkpoints === true && item.type_answer !== 'numericInput' && item.type_answer !== 'textInput' && item.type_answer !== "slider" && item.type_answer !== 'sequenceOrdering') &&
                                                    <>
                                                        <img
                                                            src={answer.points > 0 ? checkicon : circleicon}
                                                            className={styles.img}
                                                        />
                                                        {item.checkpoints === true &&
                                                            <span><span className={styles.answer_check}>{answer.points}б </span> </span>
                                                        }

                                                    </>
                                                }

                                                {(item.checkpoints === false && item.type_answer !== 'numericInput' && item.type_answer !== 'textInput' && item.type_answer !== "slider" && item.type_answer !== 'sequenceOrdering') &&
                                                    <img
                                                        src={answer.right_answer === true ? checksquareicon : squareicon}
                                                        className={styles.img}
                                                    />
                                                }

                                                {(item.type_answer === 'sequenceOrdering') &&
                                                    <>
                                                        <DraftContent draftData={answer.title} />
                                                        <select
                                                            className={styles.point_check_num_text}
                                                            value={
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.sequences_selectedNumber || ""
                                                            }

                                                        >
                                                            {


                                                                <option value={
                                                                    item_selected_data
                                                                        .find(item => item.userusetestpart_employee_tests
                                                                            .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                        .find(test => test.answer === answer.id)?.sequences_selectedNumber || 1
                                                                }>{
                                                                        item_selected_data
                                                                            .find(item => item.userusetestpart_employee_tests
                                                                                .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                            .find(test => test.answer === answer.id)?.sequences_selectedNumber || 1
                                                                    }</option>

                                                            }
                                                        </select>
                                                    </>
                                                }
                                                {(item.type_answer === 'slider') &&
                                                    <div style={{ display: 'flex', flexDirection: 'column', width: '100%', gap: "5px" }}>
                                                        <div>
                                                            <h4 >{answer.type_input_txt}</h4>

                                                        </div>

                                                        <div className={styles.slider_min_max}>

                                                            <input
                                                                id="slider"
                                                                type="range"
                                                                min={Math.min(Number(answer.min_len), Number(answer.max_len))}
                                                                max={Math.max(Number(answer.min_len), Number(answer.max_len))}
                                                                value={
                                                                    item_selected_data
                                                                        .find(item => item.userusetestpart_employee_tests
                                                                            .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                        .find(test => test.answer === answer.id)?.ranswer || 0
                                                                }

                                                                style={{ width: '100%' }}
                                                            />
                                                            <span className={styles.slider_min_max_res}>
                                                                {
                                                                    item_selected_data
                                                                        .find(item => item.userusetestpart_employee_tests
                                                                            .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                        .find(test => test.answer === answer.id)?.ranswer || ""
                                                                }
                                                            </span>

                                                        </div>
                                                        {item.checkpoints === true &&
                                                            <span style={{ display: 'flex', gap: "10px", alignItems: "center" }}>Верный ответ:<span className={styles.answer_check}>{answer.points}б </span> </span>
                                                        }
                                                        {item.checkpoints === false &&
                                                            <> Верный ответ:</>
                                                        }
                                                        <div className={styles.slider_min_max}>

                                                            <input
                                                                id="slider"
                                                                type="range"
                                                                min={Math.min(Number(answer.min_len), Number(answer.max_len))}
                                                                max={Math.max(Number(answer.min_len), Number(answer.max_len))}
                                                                value={
                                                                    answer.ranswer || 0
                                                                }

                                                                style={{ width: '100%' }}
                                                            />
                                                            <span className={styles.slider_min_max_res}>
                                                                {
                                                                    answer.ranswer
                                                                }
                                                            </span>

                                                        </div>
                                                    </div>
                                                }
                                                {(item.type_answer === 'numericInput') &&
                                                    <>

                                                        <input
                                                            type="number"
                                                            value={
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.type_input_int || ""
                                                            }

                                                            style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px', borderRadius: '6px', border: '0' }}
                                                            placeholder="Введите цифры"
                                                        />
                                                        {item.checkpoints === true &&
                                                            <span style={{ display: 'flex', gap: "10px", alignItems: "center" }}>Верный ответ: <span className={styles.answer_check}>{answer.points}б </span> </span>
                                                        }
                                                        <input
                                                            type="number"
                                                            value={
                                                                answer.type_input_int
                                                            }

                                                            style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px', borderRadius: '6px', border: '0', background: '#00ff006e' }}
                                                            placeholder="Введите цифры"
                                                        />

                                                    </>

                                                }

                                                {(item.type_answer === 'textInput') &&
                                                    <>
                                                        <input
                                                            type="text"
                                                            value={
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.type_input_txt || ""
                                                            }

                                                            style={{ border: '1px solid rgb(123, 123, 123)', padding: '5px 10px', borderRadius: '6px', border: '0' }}
                                                            placeholder="Введите текст"
                                                        />
                                                        <input
                                                            type="text"
                                                            value={
                                                                answer.type_input_txt
                                                            }

                                                            style={{ border: '1px solid rgb(41, 33, 33)', padding: '5px 10px', borderRadius: '6px', border: '0', background: '#00ff006e' }}
                                                            placeholder="Введите цифры"
                                                        />
                                                    </>
                                                }
                                                {(item.type_answer === 'singleSelection') &&
                                                    <>
                                                        <input
                                                            type="radio"
                                                            id={`answer-${answer.id}`}
                                                            checked={
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.right_answer || false
                                                            }

                                                        />
                                                        <DraftContent draftData={answer.title} />
                                                    </>
                                                }
                                                {(item.type_answer === 'multipleSelection') &&
                                                    <>
                                                        <input
                                                            type="checkbox"
                                                            id={`answer-${answer.id}`}
                                                            checked={
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.right_answer || false
                                                            }

                                                        />
                                                        <DraftContent draftData={answer.title} />
                                                    </>
                                                }

                                            </div>
                                        ) : (
                                            <>
                                                {item.type_answer === "freeTextAnswer" && (
                                                    <div className={styles.answer_card_header}>
                                                        <div className={styles.answer_card_second_div} >

                                                            {
                                                                item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id)?.free_response || 'Файл не найден'
                                                            }


                                                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'end' }}>

                                                                {/* <span>{String(answersData.find(data => data.answerId === answer.id)?.textValue || '').length} */}

                                                                {/* / {item.max_len}</span> */}
                                                            </div>
                                                        </div>
                                                    </div>

                                                )}
                                                {item.type_answer === "fileUpload" && (
                                                    <div className={styles.answer_card_header}>
                                                        <div className={styles.answer_card_second_div} >
                                                            <>
                                                                {item_selected_data
                                                                    .find(item => item.userusetestpart_employee_tests
                                                                        .some(test => test.answer === answer.id))
                                                                    ?.userusetestpart_employee_tests
                                                                    .find(test => test.answer === answer.id) ? (
                                                                    <>
                                                                        {/* Отображение наименования файла */}
                                                                        <div>
                                                                            <strong>Наименование файла:</strong>{" "}
                                                                            {
                                                                                item_selected_data
                                                                                    .find(item => item.userusetestpart_employee_tests
                                                                                        .some(test => test.answer === answer.id))
                                                                                    ?.userusetestpart_employee_tests
                                                                                    .find(test => test.answer === answer.id)?.file
                                                                                    ?.split("/")
                                                                                    .pop() || "Имя файла не найдено"
                                                                            }
                                                                        </div>

                                                                        <br></br>
                                                                        <button
                                                                            className={styles.button_style}
                                                                            onClick={() => {
                                                                                const fileUrl = item_selected_data
                                                                                    .find(item => item.userusetestpart_employee_tests
                                                                                        .some(test => test.answer === answer.id))
                                                                                    ?.userusetestpart_employee_tests
                                                                                    .find(test => test.answer === answer.id)?.file;

                                                                                if (fileUrl) {
                                                                                    const link = document.createElement("a");
                                                                                    link.href = fileUrl;
                                                                                    link.download = "downloaded_file"; // Укажите имя для загружаемого файла
                                                                                    document.body.appendChild(link);
                                                                                    link.click();
                                                                                    document.body.removeChild(link);
                                                                                } else {
                                                                                    alert("Файл для скачивания не найден");
                                                                                }
                                                                            }}
                                                                        >
                                                                            Скачать файл
                                                                        </button>
                                                                    </>
                                                                ) : (
                                                                    <div>Данные не найдены</div>
                                                                )}
                                                            </>

                                                        </div>
                                                    </div>
                                                )}

                                            </>
                                        )}
                                        {answer.file &&
                                            <img
                                                src={answer.file}
                                                className={styles.img_file}
                                            />
                                        }
                                    </div>

                                </>
                            ))}
                            {item.comment ?
                                <div style={{ marginTop: '40px', display:'flex', flexDirection:'row', alignItems:'center', gap:'10px'}}>
                                
                                    <DraftContent draftData={item.comment} />

                                </div> : null
                            }
                        </div>
                    </>
                }
            </div>

            <hr></hr>
            <Notification notify={notify} setNotify={setNotify} />
        </div >





    );
};

export default PartWorkItemUse;
